export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tato akce trvale odstraní aktivum"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opravdu chcete pokračovat?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ano"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušit"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toto aktivum již ve svém seznamu neuvidíte."])}
}